export default __webpack_public_path__ + "static/media/round_loading_bar.c47075a6.gif";